import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { OrganisationService } from '@src/core/services';

import { LoyaltyProgramListProduct } from '../../../models';

@Component({
  selector: 'product-row-item',
  templateUrl: './product-row-item.component.html',
  styleUrls: ['./product-row-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductRowItemComponent implements OnInit {
  private readonly organisationService = inject(OrganisationService);

  @Input() product?: LoyaltyProgramListProduct;

  /** Признак использования unionId в запросах */
  private useUnionId = false;

  get coverImgId() {
    return this.product?.coverImageId;
  }

  get discountText() {
    return this.product?.discountText;
  }

  /** ID ассоциации внешней базы */
  get externalUnionId(): string | undefined {
    return this.useUnionId ? this.product?.unionId : undefined;
  }

  ngOnInit(): void {
    this.organisationService.currentParentOrganisation$.subscribe(() => {
      this.setUseUnionId();
    });
  }

  /** Заполняем признак использования unionId */
  setUseUnionId() {
    this.useUnionId = this.product?.unionId
      ? this.organisationService.currentParentOrganisation$.value?.id !== this.product.unionId
      : false;
  }
}
